// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckboxGroup_checkbox__C5q1m","checkbox-group":"CheckboxGroup_checkbox-group__nwS+1"};